import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="footer footer-four pt-4">
      {/* Footer Top */}
      <div className="footer-top aos" data-aos="fade-up">
        <div className="container">
          <div className="row">
            {/* Footer Contact */}
       <div className="col-lg-3">
  <div className="footer-contact footer-widget">
    <div className="footer-logo mb-3">
      <img src="/images/logo.jpg" className="img-fluid aos" alt="logo" />
    </div>

    <div className="footer-contact-info">
      <p className="text-white">
        We offer a diverse fleet of vehicles to suit every need, including compact cars, sedans, SUVs, and luxury vehicles.
      </p>

      {/* Phone */}
      <p className="d-flex align-items-center mb-2">
        <i className="fas fa-phone-alt me-2" style={{ color: "#CE8304" }}></i>
        <a href="tel:+919529697070" style={{ color: "#fff", textDecoration: "none" }}>+91 9529697070</a>
      </p>
       <p className="d-flex align-items-center mb-2">
        <i className="fas fa-phone-alt me-2" style={{ color: "#CE8304" }}></i>
        <a href="tel:+919552937070" style={{ color: "#fff", textDecoration: "none" }}>+91 9552937070</a>
      </p>

      {/* Address */}
      <p className="d-fle align-items-start text-white">
        
        <h6><i className="fas fa-map-marker-alt me-2 mt-1 " style={{ color: "#CE8304" }}></i>Aaradhya Travels</h6>
      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058

      </p>
    </div>






<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2714.6577649950773!2d73.78479837519102!3d18.49408328259439!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTjCsDI5JzM4LjciTiA3M8KwNDcnMTQuNSJF!5e1!3m2!1sen!2sin!4v1779795412849!5m2!1sen!2sin" width="100%" height="250" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>


    <li className="d-flex gap-3">
              <a href="https://www.instagram.com/aaradhyatravels99/" target="_blank" rel="noreferrer">
                <i className="fab fa-instagram text-white"></i>
              </a>

              <a href="https://www.facebook.com/profile.php?id=61590624514268" target="_blank" rel="noreferrer">
                <i className="fab fa-facebook-f text-white"></i>
              </a>

              <a href="https://x.com/aaradhyatravel9" target="_blank" rel="noreferrer">
                <i className="fab fa-twitter text-white"></i>
              </a>

               <a href="https://www.pinterest.com/aaradhyatravels1111/" target="_blank" rel="noreferrer">
                <i className="fab fa-pinterest-p text-white"></i>
              </a>
            </li>
  </div>
</div>

            {/* Footer Menus */}
            <div className="col-lg-9">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>
            
<li><Link to="/Tempo-Traveller-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller On Rent in Pune</Link></li>

<li><Link to="/Pune-to-Mahabaleshwar-Tempo-Traveller"><i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Tempo Traveller</Link></li>

<li><Link to="/Pune-to-Outstation-Tempo-Traveller"><i className="fa fa-car darkcolor"></i> Pune to Outstation Tempo Traveller</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Pune</Link></li>

<li><Link to="/Outstation-Mini-Bus-on-Rent-Pune"><i className="fa fa-car darkcolor"></i> Outstation Mini Bus on Rent Pune</Link></li>

<li><Link to="/14-Seater-Tempo-Traveller-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 14 Seater Tempo Traveller on Rent in Pune</Link></li>

<li><Link to="/17-Seater-Bus-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 17 Seater Bus on Rent in Pune</Link></li>

<li><Link to="/Pune-to-Shirdi-Tempo-Traveller"><i className="fa fa-car darkcolor"></i> Pune to Shirdi Tempo Traveller</Link></li>

<li><Link to="/20-Seater-Bus-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 20 Seater Bus on Rent in Pune</Link></li>

<li><Link to="/25-Seater-Tempo-Traveller-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 25 Seater Tempo Traveller on Rent in Pune</Link></li>

<li><Link to="/Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad"><i className="fa fa-car darkcolor"></i> Tempo Traveller on Rent in Pimpri Chinchwad</Link></li>

<li><Link to="/32-Seater-Bus-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 32 Seater Bus Rent in Pune</Link></li>

<li><Link to="/35-Seater-Bus-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 35 Seater Bus on Rent in Pune</Link></li>

<li><Link to="/45-Seater-Bus-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 45 Seater Bus on Rent in Pune</Link></li>

<li><Link to="/50-Seater-Bus-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 50 Seater Bus On Rent in Pune</Link></li>

<li><Link to="/Non-AC-Bus-Rental-Service-in-Pune"><i className="fa fa-car darkcolor"></i> Non AC Bus Rental Service in Pune</Link></li>

<li><Link to="/Luxury-Bus-Rental-in-Pune"><i className="fa fa-car darkcolor"></i> Luxury Bus Rental in Pune</Link></li>

<li><Link to="/Luxury-Force-Urbania-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Luxury Force Urbania On Rent in Pune</Link></li>

<li><Link to="/Force-Urbania-Luxury-Mini-Bus-On-Rent"><i className="fa fa-car darkcolor"></i> Force Urbania Luxury Mini Bus On Rent</Link></li>

{/* <li><Link to="/Mini-Bus-On-Rent-in-Pune-2"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Pune</Link></li> */}

<li><Link to="/14-17-20-25-Seater-Bus-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 14 17 20 25 Seater Bus on Rent in Pune</Link></li>

<li><Link to="/Travel-Agents-in-Pune-for-Mini-Bus-Hire"><i className="fa fa-car darkcolor"></i> Travel Agents in Pune for Mini Bus Hire</Link></li>

<li><Link to="/Tempo-Traveller-Hire-in-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller Hire in Pune</Link></li>

<li><Link to="/Force-Urbania-On-Rent-for-Ashtavinayak-Darshan"><i className="fa fa-car darkcolor"></i> Force Urbania On Rent for Ashtavinayak Darshan</Link></li>

<li><Link to="/Pune-to-Mahabaleshwar-Urbania-On-Rent"><i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Urbania On Rent</Link></li>

<li><Link to="/Pune-to-Bhimashankar-Mini-Bus-Hire-in-Pune"><i className="fa fa-car darkcolor"></i> Pune to Bhimashankar Mini Bus Hire in Pune</Link></li>

<li><Link to="/Bus-Hire-for-School-Trips-in-Pune"><i className="fa fa-car darkcolor"></i> Bus Hire for School Trips in Pune</Link></li>

<li><Link to="/Pune-Local-Bus-on-Rent"><i className="fa fa-car darkcolor"></i> Pune Local Bus on Rent</Link></li>

<li><Link to="/Bus-On-Rent-in-Kharadi-Pune"><i className="fa fa-car darkcolor"></i> Bus On Rent in Kharadi Pune</Link></li>
                   <li><Link to="/Bus-on-Rent-in-Hinjewadi"><i className="fa fa-car darkcolor"></i> Bus on Rent in Hinjewadi</Link></li>

<li><Link to="/Tempo-Traveller-hire-in-Hinjewadi-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller hire in Hinjewadi Pune</Link></li>

<li><Link to="/Tempo-Traveller-on-Rent-in-Kharadi-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller on Rent in Kharadi Pune</Link></li>

                   
                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
  <ul>

<li><Link to="/Tempo-Traveller-hire-in-Wakad-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller hire in Wakad Pune</Link></li>

<li><Link to="/Tempo-Traveller-on-Rent-in-Baner-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller on Rent in Baner Pune</Link></li>

<li><Link to="/Tempo-Traveller-hire-in-Hadapsar-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller hire in Hadapsar Pune</Link></li>

{/* <li><Link to="/Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad-2"><i className="fa fa-car darkcolor"></i> Tempo Traveller on Rent in Pimpri Chinchwad</Link></li> */}

<li><Link to="/Tempo-Traveller-hire-in-Viman-Nagar-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller hire in Viman Nagar Pune</Link></li>

<li><Link to="/Tempo-Traveller-on-Rent-in-Kothrud-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller on Rent in Kothrud Pune</Link></li>

<li><Link to="/Tempo-Traveller-hire-in-Wagholi-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller hire in Wagholi Pune</Link></li>

<li><Link to="/Tempo-Traveller-on-Rent-in-Aundh-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller on Rent in Aundh Pune</Link></li>

<li><Link to="/Tempo-Traveller-hire-in-Magarpatta-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller hire in Magarpatta Pune</Link></li>

<li><Link to="/Tempo-Traveller-on-Rent-in-Bavdhan-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller on Rent in Bavdhan Pune</Link></li>

<li><Link to="/Tempo-Traveller-hire-in-Pimple-Saudagar-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller hire in Pimple Saudagar Pune</Link></li>

<li><Link to="/Tempo-Traveller-on-Rent-in-Chinchwad-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller on Rent in Chinchwad Pune</Link></li>

<li><Link to="/Wedding-Mini-Bus-Rental-in-Pune"><i className="fa fa-car darkcolor"></i> Wedding Mini Bus Rental in Pune</Link></li>

<li><Link to="/Pune-to-Shirdi-Mini-Bus"><i className="fa fa-car darkcolor"></i> Pune to Shirdi Mini Bus</Link></li>

<li><Link to="/Pune-to-Mahabaleshwar-Mini-Bus"><i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Mini Bus</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Hinjewadi"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Hinjewadi</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Wakad"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Wakad</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Baner"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Baner</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Kharadi"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Kharadi</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Hadapsar"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Hadapsar</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Pimpri-Chinchwad"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Pimpri Chinchwad</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Viman-Nagar"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Viman Nagar</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Kothrud"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Kothrud</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Wagholi"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Wagholi</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Aundh"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Aundh</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Bavdhan"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Bavdhan</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Magarpatta"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Magarpatta</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Pimple-Saudagar"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Pimple Saudagar</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Chinchwad-Pune"><i className="fa fa-car darkcolor"></i> Mini Bus in Chinchwad Pune</Link></li>
                      <li><Link to="/Mini-Bus-On-Rent-in-Nigdi-Pune"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Nigdi Pune</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Ravet-Pune"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Ravet Pune</Link></li>
<li><Link to="/Mini-Bus-On-Rent-in-Talegaon-Pune"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Talegaon Pune</Link></li>

              </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>



<li><Link to="/Mini-Bus-On-Rent-in-Bhosari-Pune"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Bhosari Pune</Link></li>      


<li><Link to="/Mini-Bus-On-Rent-in-Moshi"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Moshi</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Dhankawadi-Pune"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Dhankawadi Pune</Link></li>

<li><Link to="/Mini-Bus-Hire-in-Karve-Nagar-Pune"><i className="fa fa-car darkcolor"></i> Mini Bus Hire in Karve Nagar Pune</Link></li>

<li><Link to="/Mini-Bus-Hire-in-Sinhagad-Road-Pune"><i className="fa fa-car darkcolor"></i> Mini Bus Hire in Sinhagad Road Pune</Link></li>

<li><Link to="/Mini-Bus-Hire-in-Narhe-Pune"><i className="fa fa-car darkcolor"></i> Mini Bus Hire in Narhe Pune</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Camp-Pune"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Camp Pune</Link></li>

<li><Link to="/13-Seater-AC-Tempo-Traveller-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 13 Seater AC Tempo Traveller on Rent Pune</Link></li>

<li><Link to="/17-Seater-Tempo-Traveller-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 17 Seater Tempo Traveller On Rent in Pune</Link></li>

<li><Link to="/20-Seater-Tempo-Traveller-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 20 Seater Tempo Traveller On Rent in Pune</Link></li>

<li><Link to="/26-Seater-Tempo-Traveller-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 26 Seater Tempo Traveller On Rent in Pune</Link></li>

<li><Link to="/32-Seater-Tempo-Traveller-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 32 seater tempo traveller on rent Pune</Link></li>

<li><Link to="/35-Seater-Bus-Rental-in-Pune"><i className="fa fa-car darkcolor"></i> 35-Seater Bus Rental in Pune</Link></li>

<li><Link to="/Multi-Seater-Bus-Rentals-in-Pune"><i className="fa fa-car darkcolor"></i> 32, 35, 40, 45, and 50 Seater Buses on Rent in Pune</Link></li>

<li><Link to="/Bus-Rental-14-17-20-25-Seater-in-Pune"><i className="fa fa-car darkcolor"></i> 14, 17, 20, and 25-Seater Bus Rental in Pune</Link></li>

<li><Link to="/Tempo-Traveller-Hire-for-Event-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller Hire for Event Pune</Link></li>

<li><Link to="/Wedding-Bus-Rental-Services-in-Pune"><i className="fa fa-car darkcolor"></i> Wedding Bus Rental Services in Pune</Link></li>

<li><Link to="/School-Picnic-Bus-Rental-Services-in-Pune"><i className="fa fa-car darkcolor"></i> School Picnic Bus Rental Services in Pune</Link></li>

<li><Link to="/Urbania-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Urbania On Rent in Pune</Link></li>

<li><Link to="/Urbania-On-Rent-in-Pimpri-Chinchwad"><i className="fa fa-car darkcolor"></i> Urbania on Rent in Pimpri Chinchwad</Link></li>

<li><Link to="/Urbania-Hire-for-Corporate-Events-in-Pune"><i className="fa fa-car darkcolor"></i> Urbania Hire for Corporate Events in Pune</Link></li>

<li><Link to="/17-Seater-Urbania-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 17 Seater Urbania on Rent in Pune</Link></li>

<li><Link to="/14-Seater-Urbania-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 14 Seater Urbania on Rent in Pune</Link></li>

<li><Link to="/Urbania-on-Rent-in-Kharadi"><i className="fa fa-car darkcolor"></i> Urbania on Rent in Kharadi</Link></li>

<li><Link to="/Urbania-on-Rent-in-Hadapsar"><i className="fa fa-car darkcolor"></i> Urbania on Rent in Hadapsar</Link></li>

<li><Link to="/Urbania-on-Rent-in-Kothrud"><i className="fa fa-car darkcolor"></i> Urbania on Rent in Kothrud</Link></li>

<li><Link to="/Urbania-On-Rent-in-Bibwewadi"><i className="fa fa-car darkcolor"></i> Urbania On Rent in Bibwewadi</Link></li>

<li><Link to="/Urbania-on-Rent-in-Koregaon-Park"><i className="fa fa-car darkcolor"></i> Urbania on Rent in Koregaon Park</Link></li>

<li><Link to="/Pune-to-Ujjain-Tempo-Traveller-on-Rent"><i className="fa fa-car darkcolor"></i> Pune to Ujjain Tempo Traveller on Rent</Link></li>

<li><Link to="/Pune-to-Ashtavinayak-Darshan-Tempo-Traveller"><i className="fa fa-car darkcolor"></i> Pune to Ashtavinayak Darshan Tempo Traveller</Link></li>                </ul>
                
                
                
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <div className="row align-items-center row-gap-3 text-center">
              <div className="col-12">
                  <p className="copyright-text text-white">
              All Rights Reserved &copy;  <span className="darkcolorrr">Aaradhya Travels</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Urva Hosting</span>
              </a>
              </p>
              </div>
              {/* <div className="col-lg-4">
                <div className="payment-list">
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-01.svg" alt="img" />
                  </a>
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-02.svg" alt="img" />
                  </a>
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-03.svg" alt="img" />
                  </a>
                </div>
              </div> */}
              {/* <div className="col-lg-4">
                <ul className="privacy-link">
                  <li><a href="privacy-policy.html">Privacy</a></li>
                  <li><a href="terms-condition.html">Terms & Condition</a></li>
                  <li><a href="javascript:void(0);">Refund Policy</a></li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


